<template>
  <div class="hjqy">
    <div class="common_title clearfix">
      <div class="icon"><i class="icons i4"></i></div><p>2017获奖企业</p>
    </div>

    <div class="hjqy_detail">
      <div class="title_y">安永复旦中国最具潜力企业2017获奖名单（排名不分先后）</div>
      <div class="title_1">
        <div>公司名称</div>
        <div>董事长/首席执行官</div>
      </div>
      <div class="list_wrap">
        <div class="list_title">
          最具潜力企业
        </div>
        <router-link to="/hjqy/detail">
          <div class="list_item">
            <div class="clearfix">
              <div class="item_company">劳道农业（新疆劳道农业科技有限公司）</div>
              <div class="item_name">蒋萧阳</div>
            </div>
          </div>
        </router-link>
        <div class="list_item">
          <div class="clearfix">
            <div class="item_company">劳道农业（新疆劳道农业科技有限公司）</div>
            <div class="item_name">蒋萧阳</div>
          </div>
        </div>
        <div class="list_item">
          <div class="clearfix">
            <div class="item_company">劳道农业（新疆劳道农业科技有限公司）</div>
            <div class="item_name">蒋萧阳</div>
          </div>
        </div>
      </div>
      <div class="list_wrap">
        <div class="list_title">
          最具潜力种子企业
        </div>
        <div class="list_item">
          <div class="clearfix">
            <div class="item_company">劳道农业（新疆劳道农业科技有限公司）</div>
            <div class="item_name">蒋萧阳</div>
          </div>
        </div>
        <div class="list_item">
          <div class="clearfix">
            <div class="item_company">劳道农业（新疆劳道农业科技有限公司）</div>
            <div class="item_name">蒋萧阳</div>
          </div>
        </div>
        <div class="list_item">
          <div class="clearfix">
            <div class="item_company">劳道农业（新疆劳道农业科技有限公司）</div>
            <div class="item_name">蒋萧阳</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'zxxy'
}
</script>

<style scoped>
  i.i4{
    width: 0.33rem;
    height: 0.32rem;
    background-position: -0.1rem -2.09rem;
  }
  .hjqy_detail{
    padding: 0 0.42rem;
  }
  .hjqy_detail .title_y{
    height: 0.36rem;
    line-height: 0.36rem;
    text-align: center;
    background-color: #ffd200;
    font-size: 0.1778rem;
    color: #000000;
    margin-bottom: 0.02rem;
  }
  .hjqy_detail .title_1{
    height: 0.36rem;
    line-height: 0.36rem;
    text-align: center;
    font-size: 0.1778rem;
    color: #000000;
    margin-bottom: 0.02rem;
    background-color: #acacac;
    padding:0 0.18rem;
  }
  .hjqy_detail .title_1>div{
    width: 50%;
    float: left;
    text-align: left;
  }
  .hjqy_detail .title_1>div:last-child{
    text-align: right;
  }
  .list_title{
    font-size: 0.2rem;
    color: #ffd200;
    height: 0.36rem;
    line-height: 0.36rem;
    text-align: center;
    background-color: #616161;
  }
  .list_item{
    padding: 0.1rem;
    border-bottom: 1px dashed #707174;
  }
  .list_item>div{
    padding: 0 0.16rem;
    font-size: 0.16rem;
    color: #000;
  }
  .item_company{
    float: left;
    width: 4rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .item_name{
    float: right;
    width: 0.7rem;
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .list_wrap{
    margin-bottom: 0.24rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/hjqy.vue